import type { CSSProperties } from 'react'

export const sideNavwrapperStyle: CSSProperties = {
  boxSizing: 'border-box',
  display: 'grid',
  gridTemplateRows: '1fr auto',
  height: '100%',
  justifyContent: 'space-between',
  padding: '14px 0 60px',
  overflowY: 'auto',
  overflowX: 'hidden'
}

export const logoWrapperStyle: CSSProperties = {
  padding: '0 24px 14px'
}

export const collapseWidth = '79px'

export const expandWidth = '175px'
